<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-03",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 44,
      nextPage: '/questionnaire/section3/4',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'How often do you eat meat?',
        btn: [
          [
            {
              text: 'Eat three meals a day',
              operation: 'flag3-1_Anything_add suggestion 5 & flag3-3 true'
            }
          ],[
            {
              text: 'Once a day',
            }
          ],[
            {
              text: 'Eat every two or three days',
            }
          ],[
            {
              text: 'Rarely',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
